var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('Title',{attrs:{"title":"平台帮助"}}),_c('div',{staticClass:"ct_box",domProps:{"innerHTML":_vm._s(_vm.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }